import { baseThemeValues } from 'constants/common';

const linkBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
};

const linkPrimary = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '16px',
};

const linkBaseVariation = {
  bold: {
    ...linkBase,
    fontWeight: 600,
  },
  primary: {
    ...linkPrimary,
    fontWeight: 400,
  },
  regular: {
    ...linkBase,
    fontWeight: 400,
  },
};

export const linkThemeVariants = (variant: 'bold' | 'primary' | 'regular') => ({
  read: {
    base: {
      ...linkBaseVariation[variant],
      text: 'palette.tertiary.50',
    },
    disabled: {
      ...linkBaseVariation[variant],
      text: 'palette.neutral.40',
    },
    hover: {
      ...linkBaseVariation[variant],
      text: 'palette.tertiary.60',
    },
    pressed: {
      ...linkBaseVariation[variant],
      text: 'palette.tertiary.70',
    },
  },
  unread: {
    base: {
      ...linkBaseVariation[variant],
      text: 'palette.primary.40',
    },
    baseProps: linkBaseVariation[variant],
    disabled: {
      ...linkBaseVariation[variant],
      text: 'palette.neutral.40',
    },
    hover: {
      ...linkBaseVariation[variant],
      text: 'palette.primary.50',
    },
    pressed: {
      ...linkBaseVariation[variant],
      text: 'palette.primary.60',
    },
  },
});

export const linkTheme = {
  bold: linkThemeVariants('bold'),
  primary: linkThemeVariants('primary'),
  regular: linkThemeVariants('regular'),
};
